import React from "react";
import {
  Drawer,
  Typography,
  IconButton,
  Box,
  Divider,
  Chip,
  Stack,
  Avatar
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AlarmIcon from "@mui/icons-material/Alarm";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";

const notifications = [
  {
    id: 1,
    type: "reminder",
    title: "Call Mr. Sharma",
    time: "Today at 4:00 PM"
  },
  {
    id: 2,
    type: "reminder",
    title: "Site visit scheduled",
    time: "Tomorrow 10:00 AM"
  },
  {
    id: 2,
    type: "reminder",
    title: "Loan Document",
    time: "Tomorrow 11:50 AM"
  },
  {
    id: 3,
    type: "update",
    title: "Lead assigned to Priya",
    time: "1 hr ago"
  },
  {
    id: 4,
    type: "comment",
    title: "New comment on Inquiry #5843",
    time: "2 hrs ago"
  }
];

export default function NotificationDrawer({ open, onClose }) {
  const reminders = notifications.filter((n) => n.type === "reminder");
  const others = notifications.filter((n) => n.type !== "reminder");

const renderCard = (item, isReminder = false) => (
  <Box
    key={item.id}
    sx={{
              borderRadius: 1.5,
      p: 1.2,
      mb: 1.5,
      backgroundColor: isReminder ? "#fff5f5" : "#f9f9f9",
      borderLeft: isReminder ? "4px solid #e53935" : "3px solid #90caf9",
      boxShadow: isReminder ? 2 : 1,
      display: "flex",
      alignItems: "flex-start",
      gap: 1.5,
    }}
  >
    <Avatar
      sx={{
        bgcolor: isReminder ? "error.main" : "primary.main",
        width: 28,
        height: 28,
      }}
    >
      {isReminder ? (
        <AlarmIcon style={{ fontSize: "1.2rem" }} />
      ) : (
        <NotificationsNoneIcon sx={{ fontSize: "0.95rem" }} />
      )}
    </Avatar>

    <Box flex={1}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Typography variant="body2" fontWeight={600}>
          {item.title}
        </Typography>

        {isReminder && (
          <Chip
            label="Reminder"
            color="error"
            size="small"
            variant="outlined"
            sx={{ ml: 1}}
          />
        )}
      </Box>

      <Typography variant="caption" color="text.secondary" >
        {item.time}
      </Typography>
    </Box>
  </Box>
);



  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 430, p: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" fontWeight={700}>
            Notifications
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
           <Divider sx={{ my: 2 }} />
        {reminders.length > 0 && (
          <Box>
            <Typography variant="subtitle2" color="error" style={{marginBottom:"8px"}}>
              Reminders
            </Typography>
            {reminders.map((r) => renderCard(r, true))}
            <Divider sx={{ my: 3 }} />
          </Box>
        )}

        <Typography variant="subtitle2" color="text.secondary" style={{marginBottom:"8px"}}>
          Other Notifications
        </Typography>
        <Stack spacing={2}>
          {others.map((n) => renderCard(n))}
        </Stack>
      </Box>
    </Drawer>
  );
}
